module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_vm._v("Dashboard")])], 1)])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n      © Coded with\n      "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/cristijora",
      "target": "_blank"
    }
  }, [_vm._v("Cristi Jora")]), _vm._v(".\n      Designed by "), _c('a', {
    attrs: {
      "href": "https://www.creative-tim.com/?ref=pdf-vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Creative Tim")]), _vm._v(".\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88561068!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/ContentFooter.vue
// module id = 171
// module chunks = 2